import React from 'react'
import PropTypes from 'prop-types'
import {
  Icon
} from 'belle-js'
import classnames from 'classnames'
import styles from './Bullet.module.scss'

const Bullet = (props) => {
  const { text, icon, className, textClassName } = props

  const liClasses = classnames(
    styles.bullet,
    className,
  )

  const textClasses = classnames(
    styles.bulletText,
    textClassName,
  )
  
  return (
    <li className={liClasses}>
      <div className={styles.liContent}>
        { icon && (
          <div className={styles.iconWrapper}>
            <Icon icon="checked" width={15} height={15} iconClasses={styles.bulletIcon} />
          </div>
        ) }
        <div className={textClasses}>
          {text}
        </div>
      </div>
    </li>
  )
}

Bullet.defaultProps = {
  icon: '',
  className: '',
  textClassName: '',
}

Bullet.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.any)]),
  textClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.any)])
}

export default Bullet



// WEBPACK FOOTER //
// ./src/components/Onboarding/Shared/Bullet/Bullet.jsx